import { forwardRef } from 'react';

import { ScrollArea, ScrollAreaProps } from '@mantine/core';

interface ScrollAreaWithChildren extends ScrollAreaProps {
  children: React.ReactNode | React.ReactNode[];
}

// Create the custom scroll Area, a scrollable area without scroll bars
const ModalHiddenScrollArea = forwardRef<HTMLDivElement, ScrollAreaWithChildren>(
  (props, ref): React.JSX.Element => (
    <ScrollArea {...props} type="never" ref={ref}>
      {props.children}
    </ScrollArea>
  )
);

ModalHiddenScrollArea.displayName = 'hiddenScrollArea';
export { ModalHiddenScrollArea };
export type { ScrollAreaWithChildren };
